import { worksheets_nav_items } from '../routes/worksheets/worksheets_common.js';
import { bundles_nav_items } from '../routes/bundles/bundles_common.js';
import { courses_nav_items } from '../routes/courses/courses_common.js';

export function match(value) {
    if (!value) return false;

    const age_group_items = [
        ...worksheets_nav_items,
        ...courses_nav_items,
        ...bundles_nav_items
    ];

    return age_group_items.some((item) => item.path && item.path === value);
}
